var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocAccepted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20,22H2c-1.10254,0-2-.89746-2-2V2C0,.89697.89746,0,2,0h18c1.10254,0,2,.89697,2,2v18c0,1.10254-.89746,2-2,2ZM2,2h-.00098l.00098,18h18V2H2Z",
    fill: "#262626",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "m4.79929,11.78212c1.12159,1.39082,2.34245,2.69858,3.653,3.913.56618.51764,1.43382.51764,2,0,2.57-2.383,5.008-4.811,7.329-7.421,1.177-1.325-.81-3.259-2-1.925-2.325,2.61-4.764,5.034-7.329,7.421h2c-1.31066-1.21431-2.53153-2.52207-3.653-3.913-1.214-1.312-3.206.622-2,1.925Z",
    fill: "#00be3c",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocAccepted);
export default __webpack_public_path__ + "static/media/doc_accepted.7c07ded5d8331e490275de34200584c7.svg";
export { ForwardRef as ReactComponent };